import { combineReducers } from 'redux';
import buyerReducer from './buyerReducer';
import sellerReducer from './sellerReducer';
import exitAuditReducer from './exitAuditReducer';
import driveFileReducer from './driveFileReducer';
import dataroomReducer from './dataroomReducer';
import exitNavigatorReducer from './exitNavigatorReducer';
import dealReducer from './dealReducer';
import breakwaterDriveReducer from './breakwaterDriveReducer';
import ragStoreReducer from './ragStoreReducer';
import authReducer from './authReducer';
import employeeReducer from './employeeReducer';
import partnerReducer from './partnerReducer';
import commentReducer from './commentReducer';
import agentEscalationReducer from './agentEscalationReducer';
import dealroomAnalyticsReducer from './dealroomAnalyticsReducer';
import buyerOutreachReducer from './buyerOutreachReducer';

const appReducer = combineReducers({
  buyerStore: buyerReducer,
  sellerStore: sellerReducer,
  exitAuditStore: exitAuditReducer,
  driveFileStore: driveFileReducer,
  dataroomStore: dataroomReducer,
  exitNavigatorStore: exitNavigatorReducer,
  dealStore: dealReducer,
  breakwaterDriveStore: breakwaterDriveReducer,
  ragStoreStore: ragStoreReducer,
  authStore: authReducer,
  employeeStore: employeeReducer,
  partnerStore: partnerReducer,
  commentStore: commentReducer,
  agentEscalationStore: agentEscalationReducer,
  dealroomAnalyticsStore: dealroomAnalyticsReducer,
  buyerOutreachStore: buyerOutreachReducer,
});

const rootReducer = (state, action) => {
  return appReducer(state, action)
}

export default rootReducer;
